import DeviceMaintenance from 'features/Integrations/features/device-maintenance/DeviceMaintenance.index';

export default function DeviceMaintenanceRoute() {
  return <DeviceMaintenance />;
}
